<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <!-- 1 -->
    <input-form-penilaian :tables="tableInput.inputForm1" :listInput="listInput.inputForm1" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :modalName="'modal_add_iujp'"
      :disabled="$store.state.k3lStore.is_preview" />
    <desc-penilaian :tables="tableDesc.inputForm1" :listInput="listDesc.inputForm1" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'" />
    <block-label :label="'4. PENGELOLAAN B3'" />
    <plain-label :label="'Berikan penjelasan rinci mengenai pengelolaan Bahan Berbahaya dan Beracun (B3) di perusahaan Anda'
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGrup4'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="true" />
    <plain-label :label="'Lampirkan prosedur mengenai pengelolaan material B3 yang telah di setujui oleh manajemen dan telah di sosialisasikan kepada karyawan (Form Absensi dan Foto dokumentasi)'
      " />
    <upload-file :modelName="'prosedurB3'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :disabled="true" :docId="12" />
    <plain-label :label="'Lampirkan program mengenai pengelolaan material B3 yang telah di setujui oleh manajemen dan telah di sosialisasikan kepada karyawan'
      " />
    <upload-file :modelName="'programB3'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :disabled="true" :docId="13" />
    <plain-label :label="'Lampirkan bukti implementasi program pengelolaan material B3 (Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'implementasiB3'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :disabled="true" :docId="14" />
    <!-- 5 -->
    <input-form-penilaian :tables="tableInput.inputForm2" :listInput="listInput.inputForm2" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :modalName="'modal_add_iujp'"
      :disabled="$store.state.k3lStore.is_preview" />
    <desc-penilaian :tables="tableDesc.inputForm2" :listInput="listDesc.inputForm2" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'" />
    <block-label :label="'5. PENGELOLAAN LIMBAH'" />
    <plain-label :label="'Berikan penjelasan rinci mengenai pengelolaan limbah (padat, cair, dan gas) dan limbah B3 perusahaan Anda'
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGrup5'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="true" />
    <plain-label :label="'Lampirkan prosedur pengelolaan limbah padat, cair & B3 secara umum dan khusus (pemilahan sampah, penerapan reduce, reuse & recycle) yang telah di setujui oleh manajemen'
      " />
    <upload-file :modelName="'prosedurLimbah'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :disabled="true" :docId="15" />
    <plain-label :label="'Lampirkan program pengelolaan limbah padat, cair & B3 secara umum dan khusus (pemilahan sampah, penerapan reduce, reuse & recycle) yang telah di setujui oleh manajemen'
      " />
    <upload-file :modelName="'programLimbah'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :disabled="true" :docId="16" />
    <plain-label :label="'Lampirkan bukti sosialisasi Prosedur & program pengelolaan limbah padat, cair & B3 kepada karyawan. (Form Absensi & Foto Dokumentasi Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'buktiPengelolaanLimbah'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :disabled="true" :docId="17" />
    <plain-label :label="'Lampirkan bukti implementasi Prosedur & program pengelolaan limbah padat, cair & B3 kepada karyawan. (Minimal 3 Bukti dalam 1 Dokumen, Contoh: Neraca limbah B3, laporan penyerahan limbah B3, program 3R)'
      " />
    <upload-file :modelName="'implementasiLimbah'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :disabled="true" :docId="18" />
    <!-- 6 -->
    <input-form-penilaian :tables="tableInput.inputForm3" :listInput="listInput.inputForm3" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :modalName="'modal_add_iujp'"
      :disabled="$store.state.k3lStore.is_preview" />
    <desc-penilaian :tables="tableDesc.inputForm3" :listInput="listDesc.inputForm3" :modelName="'addedIUJP'"
      :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'" />
    <block-label :label="'6. PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)'" />
    <div class="vendor-form-wrapper">
      <input-fill-form :label="'KEGIATAN PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)'" :tables="[
      {
        name: 'Golden Rules',
        obj_name: 'desc',
        css: 'column100',
        input: false,
        type: '',
      },
    ]" :modelName="'addedGoldenRules'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'"
        :storeName="'k3lStore'" :modalName="'modal_add_golden_rules'" :disabled="true" />
    </div>
    <plain-label :label="'Lampirkan Program Fatal Prevention yang telah di setujui oleh pimpinan perusahaan'
      " />
    <upload-file :modelName="'programFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :disabled="true" :docId="19" />
    <plain-label :label="'Lampirkan bukti sosialisasi dan kampanye program Fatal Prevention kepada karyawan (Form Absensi & Foto Dokumentasi Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'sosialisasiFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" :disabled="true" :docId="20" />
    <plain-label :label="'Lampirkan bukti implementasi program kerja terkait fatal prevention tersebut (Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'implementasiFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" :disabled="true" :docId="21" />
    <plain-label :label="'Lampirkan dokumen kerja (prosedur, standar, form) pengaturan implementasi Fatal Prevention atau Golden Rules yang telah di setujui oleh pimpinan perusahaan'
      " />
    <upload-file :modelName="'dokumenKerjaFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" :disabled="true" :docId="22" />
    <plain-label :label="'Lampirkan bukti implementasi program Fatal Prevention & dokumen kerja (prosedur, standar, form) pengaturan implementasi Fatal Prevention atau Golden Rules (Form Absensi dan Foto Dokumentasi Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'implementasiDokumenKerjaFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" :disabled="true" :docId="23" />
    <plain-label :label="'Lampirkan bukti evaluasi program Fatal Prevention yang sudah berjalan'
      " />
    <upload-file :modelName="'evaluasiFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :disabled="true" :docId="24" />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan & Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
import InputFillForm from '../../components/forms/input-fill-form.vue'
import InputFormPenilaian from '../../components/forms/input-form-penilaian.vue'
import DescPenilaian from '../../components/desc-penilaian.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
    InputFillForm,
    InputFormPenilaian,
    DescPenilaian,
  },
  data() {
    return {
      tableInput: {
        inputForm1: [
          {
            name: 'ASSESOR PENGELOLAAN K3L',
            obj_name: 'jenis',
            css: 'column40 mr10',
            input: false,
            type: 'name',
          },
          {
            name: 'BOBOT (65%)',
            obj_name: 'bidang',
            css: 'column10',
            input: false,
            type: 'subname',
          },
          {
            name: 'NILAI',
            obj_name: 'sub_bidang',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'CATATAN',
            obj_name: 'sub_bidang',
            css: 'column40',
            input: true,
            type: 'text',
          },
        ],
        inputForm2: [
          {
            name: 'ASSESOR PENGELOLAAN K3L',
            obj_name: 'jenis',
            css: 'column40 mr10',
            input: false,
            type: 'name',
          },
          {
            name: 'BOBOT (65%)',
            obj_name: 'bidang',
            css: 'column10',
            input: false,
            type: 'subname',
          },
          {
            name: 'NILAI',
            obj_name: 'sub_bidang',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'CATATAN',
            obj_name: 'sub_bidang',
            css: 'column40',
            input: true,
            type: 'text',
          },
        ],
        inputForm3: [
          {
            name: 'ASSESOR PENGELOLAAN K3L',
            obj_name: 'jenis',
            css: 'column40 mr10',
            input: false,
            type: 'name',
          },
          {
            name: 'BOBOT (65%)',
            obj_name: 'bidang',
            css: 'column10',
            input: false,
            type: 'subname',
          },
          {
            name: 'NILAI',
            obj_name: 'sub_bidang',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'CATATAN',
            obj_name: 'sub_bidang',
            css: 'column40',
            input: true,
            type: 'text',
          },
        ],
      },
      listInput: {
        inputForm1: [
          {
            type: 'label',
            label: 'PENGELOLAAN B3',
          },
          {
            type: 'form',
            name: 'ITEM 1.1',
            subname: '7.70%',
            options: ['N/A', '0', '3', '5'],
            optionStore: 'penilaian_grup4_11',
            inputStore: 'note_grup4_11',
          },
        ],
        inputForm2: [
          {
            type: 'label',
            label: 'PENGELOLAAN LIMBAH',
          },
          {
            type: 'form',
            name: 'ITEM 1.1',
            subname: '7.70%',
            options: ['N/A', '0', '3', '5'],
            optionStore: 'penilaian_grup5_11',
            inputStore: 'note_grup5_11',
          },
        ],
        inputForm3: [
          {
            type: 'label',
            label: 'PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)',
          },
          {
            type: 'form',
            name: 'ITEM 1.1',
            subname: '7.70%',
            options: ['N/A', '0', '3', '5'],
            optionStore: 'penilaian_grup6_11',
            inputStore: 'note_grup6_11',
          },
          {
            type: 'form',
            name: 'ITEM 1.2',
            subname: '15.4%',
            options: ['N/A', '0', '5', '10'],
            optionStore: 'penilaian_grup6_12',
            inputStore: 'note_grup6_12',
          },
        ],
      },
      tableDesc: {
        inputForm1: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css: 'column20 col-nohover',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_4',
            desc: 'desc_4',
            css: 'column30 col-nohover',
          },
        ],
        inputForm2: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css: 'column20 col-nohover',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_4',
            desc: 'desc_4',
            css: 'column30 col-nohover',
          },
        ],
        inputForm3: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css: 'column20 col-nohover',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_4',
            desc: 'desc_4',
            css: 'column30 col-nohover',
          },
        ],
      },
      listDesc: {
        inputForm1: [
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '3',
                title_4: '5',
              },
            ],
            item: [
              {
                type: 'label',
                label: 'PENGELOLAAN B3',
              },
              {
                type: 'desc',
                desc_1: 'ITEM 1.1',
                desc_2:
                  '1. Tidak ada prosedur dan program mengenai pengelolaan material B3.',
                desc_3: [
                  '1. Terdapat prosedur dan program mengenai pengelolaan material B3 yang telah disetujui oleh manajemen dan telah disosialisasikan kepada karyawan.',
                  '2. Disetujui oleh pimpinan tertinggi di perusahaan sesuai struktur organisasi.',
                ],
                desc_4: [
                  '1. Terdapat prosedur dan program mengenai pengelolaan material B3 yang telah disetujui oleh manajemen dan telah disosialisasikan kepada karyawan.',
                  '2. Terdapat bukti implementasi program pengelolaan material B3.',
                ],
              },
            ],
          },
        ],
        inputForm2: [
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '3',
                title_4: '5',
              },
            ],
            item: [
              {
                type: 'label',
                label: 'PENGELOLAAN LIMBAH',
              },
              {
                type: 'desc',
                desc_1: 'ITEM 1.1',
                desc_2:
                  '1. Perusahaan tidak memiliki prosedur & program pengelolaan limbah padat, cair & B3.',
                desc_3: [
                  '1. Terdapat prosedur & program pengelolaan limbah padat, cair & B3 yang telah disetujui oleh manajemen.',
                  '2. Terdapat bukti sosialisasi prosedur & program pengelolaan limbah padat, cair & B3 kepada karyawan.',
                ],
                desc_4: [
                  '1. Terdapat prosedur & program pengelolaan limbah padat, cair & B3 yang telah disetujui oleh manajemen.',
                  '2. Terdapat bukti sosialisasi prosedur & program pengelolaan limbah padat, cair & B3 kepada karyawan.',
                  '3. Terdapat bukti implementasi program pengelolaan limbah padat, cair & B3 (ex: Neraca Limbah B3, Laporan Penyerahan Limbah B3, program 3R, dll).',
                ],
              },
              // {
              //   type: 'desc',
              //   desc_1: 'ITEM 1.2',
              //   desc_2:
              //     '1. Tidak terdapat bukti dokumen risk assessment/HIRA/IBPR sesuai dengan jenis pekerjaan yang dilakukan.',
              //   desc_3:
              //     '1. Terdapat bukti dokumen risk assessment/HIRA/IBPR sesuai dengan jenis pekerjaan yang dilakukan.',
              //   desc_4: [
              //     '1. Terdapat bukti dokumen risk assessment/HIRA/IBPR sesuai dengan jenis pekerjaan yang dilakukan.',
              //     '2. Bukti implementasi dokumen risk assessment/HIRA/IBPR kepada pekerja.',
              //   ],
              // },
            ],
          },
        ],
        inputForm3: [
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '3',
                title_4: '5',
              },
            ],
            item: [
              {
                type: 'label',
                label: 'PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)',
              },
              {
                type: 'desc',
                desc_1: 'ITEM 1.1',
                desc_2:
                  '1. Tidak terdapat Program Fatal Prevention yang telah disetujui oleh pimpinan perusahaan.',
                desc_3: [
                  '1. Terdapat Program Fatal Prevention yang telah disetujui oleh pimpinan perusahaan.',
                  '2. Bukti sosialisasi Program Fatal Prevention kepada karyawan.',
                ],
                desc_4: [
                  '1. Terdapat Program Fatal Prevention yang telah disetujui oleh pimpinan perusahaan.',
                  '2. Bukti sosialisasi Program Fatal Prevention kepada karyawan.',
                  '3. Terdapat bukti implementasi program kerja terkait fatal prevention tersebut.',
                ],
              },
            ],
          },
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '5',
                title_4: '10',
              },
            ],
            item: [
              {
                type: 'desc',
                desc_1: 'ITEM 1.2',
                desc_2:
                  '1. Tidak terdapat dokumen kerja (Prosedur, standar, form) pengaturan implementasi Fatal Prevention atau Golden Rules yang telah disetujui oleh pimpinan perusahaan.',
                desc_3: [
                  '1. Terdapat dokumen kerja (Prosedur, standar, form) pengaturan implementasi Fatal Prevention atau Golden Rules yang telah disetujui oleh pimpinan perusahaan.',
                  '2. Bukti sosialisasi Program Fatal Prevention kepada karyawan.',
                ],
                desc_4: [
                  '1. Terdapat dokumen kerja (Prosedur, standar, form) pengaturan implementasi Fatal Prevention atau Golden Rules yang telah disetujui oleh pimpinan perusahaan.',
                  '2. Bukti implementasi Program Fatal Prevention dan dokumen kerja (Prosedur, standar, form) pengaturan implementasi Fatal Prevention atau Golden Rules.',
                  '3. Bukti evaluasi Program Fatal Prevention yang sudah berjalan.',
                ],
              },
            ],
          },
        ],
      },
    }
  },
  async created() {
    const route = this.$route.path
    await this.$store.commit('k3lStore/CALCULATION_1')
    await this.$store.commit('k3lStore/CALCULATION_2')
    await this.$store.commit('k3lStore/CALCULATION_3')
  },
  watch: {
    '$store.state.k3lStore.penilaian_grup4_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
    '$store.state.k3lStore.penilaian_grup5_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
    '$store.state.k3lStore.penilaian_grup6_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
    '$store.state.k3lStore.penilaian_grup6_12'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup13' })
    },
    goNext() {
      this.$store.commit('k3lStore/SAVE_DRAFT_SIPM_SUBMIT', {
        onSuccess: () => {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup78' })
        }
      })
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
